import { render, staticRenderFns } from "./ModalUsersWithoutEmail.vue?vue&type=template&id=70af073d&scoped=true&"
import script from "./ModalUsersWithoutEmail.vue?vue&type=script&lang=js&"
export * from "./ModalUsersWithoutEmail.vue?vue&type=script&lang=js&"
import style0 from "./ModalUsersWithoutEmail.vue?vue&type=style&index=0&id=70af073d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70af073d",
  null
  
)

export default component.exports